export const EDIT_PAYER                       = 'EDIT_PAYER';
export const EDIT_SUCCESS                     = 'EDIT_SUCCESS';
export const EDIT_FAILURE                     = 'EDIT_FAILURE';
export const RESTORE_CONFIG_VERSION           = 'RESTORE_CONFIG_VERSION';
export const RESTORE_CONFIG_VERSION_SUCCESS   = 'RESTORE_CONFIG_VERSION_SUCCESS';
export const RESTORE_CONFIG_VERSION_FAILURE   = 'RESTORE_CONFIG_VERSION_FAILURE';

export function editPayerAction(data) {
  return {
    type:    EDIT_PAYER,
    payload: data
  };
}

export function editSuccess(response) {
  return {
    type:    EDIT_SUCCESS,
    payload: response
  };
}

export function editFailure(error) {
  return {
    type:    EDIT_FAILURE,
    payload: error
  };
}

export function restoreConfigVersionAction(data) {
  return {
    type:    RESTORE_CONFIG_VERSION,
    payload: data
  };
}

export function restoreSuccess(response) {
  return {
    type:    RESTORE_CONFIG_VERSION_SUCCESS,
    payload: response
  };
}

export function restoreFailure(error) {
  return {
    type:    RESTORE_CONFIG_VERSION_FAILURE,
    payload: error
  };
}
